<template>
  <div class="the-header-search" v-if="showpan" v-click-outside="hideSearchPanel">
    <el-select v-model="searchType" placeholder="请选择">
      <el-option
        v-for="item in searchTypeOption"
        :key="item.value"
        :label="item.label"
        :value="item.value">
      </el-option>
    </el-select>
    <el-input v-model="searchKeyword"
              class="search-input"
              placeholder="请选择办事大厅或直接搜索事项名称..."
              @keyup.enter.native="search(searchKeyword)"
              ></el-input>
    <span v-if="showCancelBtn"
          class="cancel-search" @click="cancelSearch">取消</span>
    <i v-else class="ri-search-line search-icon" @click="search(searchKeyword)"></i>
    <transition name="search-panel">
      <div class="search-panel" v-show="isPanelShow">
        <div class="panel-title">
          <span>热门搜索</span>
          <i class="ri-fire-fill" style="margin-left: 4px;color: #FF4D4F;vertical-align: -2px;"></i>
        </div>
        <div class="hot-list" v-if="hotSearch[searchType] && hotSearch[searchType].length">
          <div class="hot-item"
               v-for="item in hotSearch[searchType]"
               :key="item"><span @click="search(item)">{{ item }}</span></div>
        </div>
        <div class="panel-title" v-show="historySearch[searchType] && historySearch[searchType].length">
          <span>最近搜索</span>
          <span class="clear-history" @click="clearHistory">清空</span>
        </div>
        <div class="history-list" v-if="historySearch[searchType] && historySearch[searchType].length">
          <div class="history-item"
               v-for="(item, index) in historySearch[searchType]"
               :key="item">
            <i class="ri-time-line"></i>
            <span @click="search(item)">{{ item }}</span>
            <i class="ri-close-line delete-history" @click="removeHistory(index)"></i>
          </div>
        </div>
        <div class="mobile-info">
          <div class="info-item">
            <div class="item-image">
              <img :src="require('@img/qrcode-app.png')">
            </div>
            <div class="item-name">{{ systemName }}</div>
            <div class="item-info">移动客户端</div>
          </div>
          <div class="info-item">
            <div class="item-image">
              <img :src="require('@img/qrcode-wechat.jpeg')">
            </div>
            <div class="item-name">{{ orgName }}</div>
            <div class="item-info">微信公众号</div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import _ from 'lodash'
import Bus from '@/api/bus'
import { systemName,orgName } from '@/config/system'
import { DIC } from '@/config/dic'
import { clickOutside } from '@/utils/directives'
import { mapGetters } from 'vuex'
export default {
  name: 'TheHeaderSearch',
  directives: { clickOutside },
  props: {
    showCancel: {
      type: Boolean,
      default: false
    }
  },
  data () {
    const typeOption = []
    const hotSearch = {}
    const historySearch = {}
    _.forEach(DIC.SEARCH_TYPE, (item, index) => {
      typeOption.push({
        value: index,
        label: item
      })
      // if (index === 'HALL') {
      //   // 大厅热门搜索
      //   // hotSearch[index] = ['济南市政务服务大厅', '高新区政务服务大厅', '历下区政务服务大厅', '天桥区政务服务大厅']
      //   // hotSearch[index] = ['公司', '法人', '企业']
      //   // 大厅历史搜索
      //   // historySearch[index] = ['高新区政务服务大厅', '历下区政务服务大厅']
      //   historySearch[index] = []
      // }
      //  else if (index === 'ITEM') {
      //   // 事项热门搜索
      //   hotSearch[index] = ['基层就业补贴', '人才入户', '企业开办', '烟草专卖零售许可证']
      //   // 事项历史搜索
      //   historySearch[index] = ['驾驶证到期换证', '企业开办', '护照申领']
      // } else if (index === 'OTHER') {
      //   // 其他热门搜索
      //   hotSearch[index] = ['公厕', '停车场', '加油站', '核酸检测点']
      //   // 其他历史搜索
      //   historySearch[index] = []
      // }
    })
    return {
      showpan:true,
      DIC: DIC,
      systemName: systemName,
      orgName: orgName,
      // 搜素类别
      searchType: typeOption[0].value,
      // 搜索类别选项
      searchTypeOption: typeOption,
      // 搜索关键字
      searchKeyword: '',
      // 热门搜索
      hotSearch: hotSearch,
      // 最近搜索
      historySearch: historySearch,
      // 搜索辅助面板
      isPanelShow: false
    }
  },
  computed: {
    ...mapGetters(['searchValue']),
    showCancelBtn () {
      const that = this
      if (!that.showCancel) {
        return false
      } else return !!(that.isPanelShow || _.trim(that.searchKeyword))
    }
  },
  mounted(){
     Bus.$on('val', (data) => {
        this.showpan=data
      })
  },
  watch: {
    searchValue (newValue) {
      const that = this
      that.searchKeyword = newValue
    },
    searchType (newValue) {
      const that = this
      that.searchKeyword = ''
      // that.$store.commit('setSearchValue', {
      //   type: null,
      //   value: null
      // })
    }
  },
  methods: {
    // 显示辅助搜索面板
    showSearchPanel () {
      const that = this
      that.isPanelShow = true
    },
    // 隐藏辅助搜索面板
    hideSearchPanel (e) {
      const that = this
      const elClass = e.target.className
      if (elClass.indexOf('delete-history') < 0) {
        that.isPanelShow = false
      }
    },
    // 取消搜索
    cancelSearch () {
      const that = this
      console.log("searchType",that.searchType) 
      Bus.$emit('val', true)
      that.searchKeyword = ''
      that.isPanelShow = false
      that.$store.commit('setSearchValue', {
        type: null,
        value: null
      })
    },
    // 清空最近搜索
    clearHistory () {
      const that = this
      that.historySearch[that.searchType] = []
    },
    // 删除单项最近搜索
    removeHistory (index) {
      const that = this
      that.historySearch[that.searchType].splice(index, 1)
    },
    // 执行搜索
    search (keyword) {
      if (!_.trim(keyword)) {
        return false
      }
      const that = this
      that.$store.commit('setSearchValue', {
        type: that.searchType,
        value: keyword
      })
      // 删除重复的搜索历史
      _.pull(that.historySearch[that.searchType], keyword)
      // 将搜索的内容插入搜索历史
      // that.historySearch[that.searchType].unshift(keyword)
      // 关闭辅助搜索框
      that.isPanelShow = false
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@style/_var.scss";
@import "~@style/_theme.scss";
.the-header-search{
  position: relative;
  display: inline-block;
  width: 380px;
  height: 36px;
  line-height: 1.15;
  margin-left: 56px;
  padding-left: 80px;
  vertical-align: middle;
  &>*{
    position: relative;
    z-index: 9;
  }
  &:before{
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: #F5F7FB;
    border-radius: 4px;
    opacity: 0.15;
  }
  .search-input{
    display: block;
    width: 100%;
    height: 100%;
    line-height: 1;
    ::v-deep .el-input__inner{
      height: 36px;
      padding-right: 48px;
      line-height: 36px;
      color: #fff;
      background-color: transparent;
      border-color: transparent;
      &::-webkit-input-placeholder {
        color: #ddd;
      }
      &::-moz-input-placeholder {
        color: #ddd;
      }
      &::-ms-input-placeholder {
        color: #ddd;
      }
    }
  }
  .search-icon{
    position: absolute;
    right: 0;
    top: 0;
    width: 48px;
    height: 36px;
    line-height: 36px;
    font-size: 18px;
    text-align: center;
    color: #fff;
    cursor: pointer;
  }
  ::v-deep .el-select{
    position: absolute;
    left: 0;
    top: 0;
    width: 80px;
    height: 100%;
    line-height: 1;
    .el-input__inner{
      height: 36px;
      line-height: 36px;
      color: #fff;
      background-color: rgba(245, 247, 251, .2);
      border-color: transparent;
    }
    .el-input__icon{
      color: #fff;
      line-height: 36px;
    }
  }
  .search-panel{
    position: absolute;
    left: 80px;
    top: 100%;
    z-index: 22;
    width: 430px;
    margin-top: 12px;
    // padding: $paddingVertical $paddingHorizontal 110px;
    padding: $paddingVertical $paddingHorizontal;
    background: #fff;
    box-shadow: 0 3px 11px 0 rgba(146, 146, 146, 0.5);
    &:before{
      content: '';
      position: absolute;
      left: 24px;
      bottom: 100%;
      width: 0;
      height: 0;
      border-style: solid;
      border-width: 0 8px 8px;
      border-color: transparent transparent #fff;
    }
    .panel-title{
      margin-bottom: 12px;
      font-weight: 500;
      color: $colorTextPrimary;
      .clear-history{
        float: right;
        font-weight: normal;
        cursor: pointer;
        color: $colorPrimary;
        font-size: 13px;
      }
    }

    $imgSize: 80px;
    .mobile-info{
      display: none;
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      height: ($imgSize + 30px);
      padding: $paddingVertical $paddingHorizontal;
      background: #F5F7FA;
      .info-item{
        float: left;
        width: 50%;
        .item-image{
          float: left;
          width: $imgSize;
          height: $imgSize;
          img{
            width: 100%;
            height: 100%;
          }
        }
        .item-name{
          margin-left: ($imgSize + 14px);
          font-size: 12px;
          color: $colorPrimary;
        }
        .item-info{
          margin-left: ($imgSize + 14px);
          margin-top: 8px;
          font-size: 12px;
        }
      }
    }
  }
  .hot-list{
    margin: 0 -8px 8px;
    overflow: hidden;
    .hot-item{
      float: left;
      width: 50%;
      padding: 0 8px;
      margin-bottom: 8px;
      span{
        display: block;
        width: 100%;
        height: 32px;
        padding: 0 8px;
        text-align: center;
        font-size: 13px;
        line-height: 30px;
        background: #F5F6FA;
        background: linear-gradient(270deg, rgba(251, 251, 253, 0.7) 0%, #F5F6FA 100%);
        border-radius: 2px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        transition: $transitionTime;
        cursor: pointer;
        &:hover{
          color: $colorPrimary;
        }
      }
    }
  }
  .history-list{
    margin: 0 -16px;
    padding-bottom: $paddingVertical;
    .history-item{
      padding: 0 16px;
      height: 36px;
      font-size: 13px;
      line-height: 36px;
      transition: $transitionTime;
      &:hover{
        background: #F5F6FA;
        background: linear-gradient(270deg, rgba(251, 251, 253, 0.7) 0%, #F5F6FA 100%);
      }
      &>*{
        line-height: 1;
      }
      i{
        margin-right: 4px;
        font-size: 14px;
        vertical-align: -3px;
        color: $colorTextSecondary;
      }
      span{
        display: inline-block;
        vertical-align: middle;
        cursor: pointer;
        max-width: 320px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        transition: $transitionTime;
        &:hover{
          color: $colorPrimary;
        }
      }
      .delete-history{
        float: right;
        width: 24px;
        height: 24px;
        margin-top: 6px;
        margin-right: 0;
        line-height: 24px;
        text-align: right;
        color: $colorTextSecondary;
        cursor: pointer;
        &:hover{
          color: $colorTextPrimary;
        }
      }
    }
  }
  .cancel-search{
    position: absolute;
    right: 0;
    top: 0;
    width: 48px;
    height: 36px;
    line-height: 36px;
    text-align: center;
    color: #fff;
    cursor: pointer;
  }
}

/* search-panel transition */
.search-panel-enter-active{
  transition: all .5s;
}

.search-panel-enter,
.search-panel-leave-active {
  opacity: 0;
  transform: translateY(32px);
}

.search-panel-move {
  transition: all .5s;
}

.search-panel-leave-active {
  position: absolute;
  transition: all .5s;
}
</style>
